import React from 'react';
import { Row, Col, Radio, Modal } from 'antd';
import { Page, Form, ContentWrapper, Button, DatePicker, Select, Input, Loading } from '~/components';
import { PrincipalService, RelatorioService, UserService } from '~/services';
import './RelatorioPage.less';

let TIPO = 'pdf';
let EMAIL = false;

class RelatorioPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoadingRelatorio: false,
      isLoadingContato: false,
      relatorios: [],
      empresas: [],
      dataItemsContato: [],
      valueRadio: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.editInput) this.editInput.focus();
    }, 300);

    this.buscarContato('RELATORIO');

    UserService.fetchEmpresas(empresas => this.setState({ empresas }));

    this.setState({ isLoadingRelatorio: true }, () => {
      RelatorioService.fetchRelatorios(
        relatorios => this.setState({ relatorios, isLoadingRelatorio: false }),
        () => this.setState({ relatorios: [], isLoadingRelatorio: false })
      );
    });
  }

  buscarContato = arquivo => {
    this.setState({ isLoadingContato: true }, () => {
      PrincipalService.getAllContato(
        arquivo,
        dataItemsContato => this.setState({ dataItemsContato, isLoadingContato: false }),
        () => this.setState({ dataItemsContato: [], isLoadingContato: false })
      );
    });
  };

  handlePrint = (tipo = 'pdf', email = false) => {
    const { valueRadio } = this.state;
    if (!valueRadio) {
      Modal.error({
        title: 'Relatório - Erro',
        content: 'Selecione um relatório para emissão.',
        centered: true,
        width: '500px',
      });
    } else {
      TIPO = tipo;
      EMAIL = email;
      this.saveApi.submitForm();
    }
  };

  gerarRelatorio = valuesForms => {
    const { relatorios, valueRadio } = this.state;
    const relatorioSelected = relatorios.find(item => item.data === valueRadio);
    const newValuesForms = {
      ...valuesForms,
      origem: valuesForms.origem && valuesForms.origem.length > 0 ? valuesForms.origem.join() : '',
    };

    const values = [];
    Object.entries(newValuesForms).forEach(([key, value = '']) => {
      if (value && Array.isArray(value)) {
        values.push({ nome_campo: key, valor: value.length > 0 ? (parseInt(value[0], 10) > 0 ? value.join() : `'${value.join("','")}'`) : '' });
      } else if (value && value !== '') {
        values.push({ nome_campo: key, valor: value.length === 10 ? value.replace('-', '').replace('-', '') : value });
      }
    });

    values.push({ nome_campo: 'cliente', valor: UserService.getUser().codigo });
    values.push({ nome_campo: 'titulo_relatorio', valor: relatorioSelected.label });
    values.push({ nome_campo: 'exporta_excel', valor: TIPO === 'excel' ? 'S' : 'N' });
    values.push({ nome_campo: 'exporta_csv', valor: TIPO === 'csv' || relatorioSelected.label === 'Listagem de Venda Detalhada' ? 'S' : 'N' });
    values.push({ nome_campo: 'retorna_pdf', valor: EMAIL ? 'S' : 'N' });
    values.push({ nome_campo: 'permissao', valor: 'S' });

    this.setState({ isLoading: true });
    RelatorioService.getChamaRelatorio(
      values,
      relatorioSelected.servlet,
      relatorioSelected.label,
      () => {
        this.setState({ isLoading: false });
      },
      () => {
        this.setState({ isLoading: false });
      }
    );
  };

  render = () => {
    const { tabId } = this.props;
    const { isLoading, isLoadingRelatorio, isLoadingContato, relatorios, empresas, valueRadio, dataItemsContato } = this.state;
    const isDisabled = !valueRadio || isLoading;

    return (
      <>
        <div className="conteudo-box relatorio">
          <div className="form borda">
            <Page tabId={tabId} closable>
              <Form getApi={api => (this.saveApi = api)} onSubmit={this.gerarRelatorio}>
                <ContentWrapper>
                  <Row gutter={4}>
                    <Col md={24} span={24}>
                      <div>Relatório</div>
                      {isLoadingRelatorio ? (
                        <Loading style={{ marginBottom: '20px' }} />
                      ) : (
                        <Radio.Group
                          disabled={isLoading || isLoadingRelatorio}
                          onChange={evt => {
                            this.setState({ valueRadio: evt.target.value });
                          }}
                          value={valueRadio}
                          name="relatorio"
                        >
                          {relatorios.map(item => (
                            <Radio key={item.id} value={item.data}>
                              {item.label}
                            </Radio>
                          ))}
                        </Radio.Group>
                      )}
                    </Col>
                  </Row>
                </ContentWrapper>
                <ContentWrapper type="search">
                  <Row gutter={4}>
                    <Col md={24} span={24}>
                      <Select
                        field="origem"
                        label="Empresa"
                        dataSource={empresas}
                        forwardedRef={ref => (this.searchInput = ref)}
                        disabled={isDisabled}
                        mode="multiple"
                        maxTagCount={2}
                        required
                      />
                    </Col>
                    <Col md={3} span={12}>
                      <DatePicker field="data_inicial" label="Data Inicial" today forwardedRef={ref => (this.editInput = ref)} disabled={isDisabled} required />
                    </Col>
                    <Col md={3} span={12}>
                      <DatePicker field="data_final" label="Data Final" today disabled={isDisabled} required />
                    </Col>
                    <Col md={4} span={12}>
                      <Input label="Placa" field="placa" type="placa" allowClear disabled={isDisabled} />
                    </Col>
                  </Row>
                </ContentWrapper>
              </Form>
            </Page>
          </div>

          <div className="painel-box">
            <div className="painel">
              <div className="aviso">
                <div className="titulo">Relatório</div>
                <div className="texto">Você consegue visualizar os relatórios de quase tudo aqui!</div>
                <div className="texto">Salvar ou imprimir em PDF, Excel e CSV</div>
              </div>

              <div className="contato">
                <div>Dúvidas entre em contato com o setor responsável:</div>
                {isLoadingContato ? (
                  <Loading />
                ) : (
                  dataItemsContato.map(item => (
                    <div key={item.nome} className="destaque">
                      <a href={`https://api.whatsapp.com/send?phone=55${item.zap}`} target="_blank" rel="noopener noreferrer nofollow">
                        {`${item.telefone} ${item.nome}`}
                      </a>
                    </div>
                  ))
                )}
              </div>
            </div>

            <div className="relatorio-titulo">Gerar Relatório</div>
            <div className="box-botao">
              <Button.Default className="botao-pdf" disabled={isLoading || isLoadingRelatorio} onClick={() => this.handlePrint('pdf', false)}>
                PDF
              </Button.Default>
              <Button.Default className="botao-excel" disabled={isLoading || isLoadingRelatorio} onClick={() => this.handlePrint('excel', false)}>
                EXCEL
              </Button.Default>
              <Button.Default className="botao-csv" disabled={isLoading || isLoadingRelatorio} onClick={() => this.handlePrint('csv', false)}>
                CSV
              </Button.Default>
            </div>
          </div>
        </div>
      </>
    );
  };
}

export default RelatorioPage;
